// The detail pane's mark for a value it doesn't know.
export const MISSING_VALUE = '-';
